'use strict';

import {DomainValues} from './DomainValues';
import {ValidationErrors} from './Validation';

function addValueProperty(property, initialValue) {
  this[property] = {
    configurable: false,
    enumerable: true,
    writable: true,
    value: initialValue
  }
}

// Define the base properties
export function DefaultProperties(instance, initialValues) {
  this.$id = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: null
  };
  this.$ref = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: null
  };
  this.$class = {
    configurable: false,
    enumerable: false,
    writable: false,
    value: initialValues.$class
  };
  this.$errors = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: new ValidationErrors()
  };
  this.$$values = {
    configurable: false,
    enumerable: false,
    writable: false,
    value: new DomainValues(instance)
  };
  this.$$persisted = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: false
  };
  this.$$listener = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: null
  };
  this.$$listeners = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: {update: []}
  };
}

DefaultProperties.prototype.addValueProperty = addValueProperty;

export function DefaultRelationProperties(instance, initialValues) {
  this.$id = { // ID of the linked collection entity aka the terminal vertex
    configurable: false,
    enumerable: false,
    writable: true,
    value: null
  };
  this.$collectionId = { // ID of the source collection entity aka the initial vertex
    configurable: false,
    enumerable: false,
    writable: true,
    value: null
  };
  this.$collectionName = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: null
  };
  this.$linkCollectionName = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: null
  };
  this.$ref = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: null
  };
  this.$class = {
    configurable: false,
    enumerable: false,
    writable: false,
    value: initialValues.$class
  };
  this.$errors = {
    configurable: false,
    enumerable: false,
    writable: true, /* TODO: Verify is the errors object should be writable. I doubt it. */
    value: new ValidationErrors()
  };
  this.$$values = {
    configurable: false,
    enumerable: false,
    writable: false,
    value: new DomainValues(instance)
  };
  this.$$persisted = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: false
  };
  this.$$updateListeners = {
    configurable: false,
    enumerable: false,
    writable: true,
    value: {update: []}
  };
}

DefaultRelationProperties.prototype.addValueProperty = addValueProperty;



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/domain-properties/Properties.js